import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatour() {



  const cardData = {
 "keyword": "Pune to Ayodhya Tour Package",

  "headingDescription":
    "Shivai Travels offers a comfortable and well-planned Pune to Ayodhya Tour Package for pilgrims and travelers seeking a peaceful spiritual journey to one of India’s most sacred cities. Ayodhya, the birthplace of Lord Shri Ram, holds immense religious and cultural significance, attracting devotees from across the country. Our tour package is designed to provide a safe, smooth, and hassle-free travel experience with well-maintained AC vehicles, experienced long-route drivers, and flexible itinerary options. Whether you are traveling with family, elders, or in a group for pilgrimage, we ensure comfort throughout the journey with doorstep pickup from Pune, customizable stops, and complete travel assistance. With options for one-way, round-trip, and extended religious circuit tours including nearby holy destinations, Shivai Travels ensures a memorable and spiritually fulfilling journey to Ayodhya.",

  "topPlaces": [
    {
      "title": "Shri Ram Janmabhoomi Temple",
      "description":
        "Shri Ram Janmabhoomi Temple is the most sacred site in Ayodhya, believed to be the birthplace of Lord Shri Ram. It is a major pilgrimage destination with grand architecture and deep religious importance."
    },
    {
      "title": "Hanuman Garhi",
      "description":
        "Hanuman Garhi is a famous temple dedicated to Lord Hanuman, located on a hilltop and known for its spiritual significance and panoramic views of Ayodhya."
    },
    {
      "title": "Kanak Bhawan",
      "description":
        "Kanak Bhawan is a beautiful temple dedicated to Lord Rama and Goddess Sita, known for its stunning architecture, gold-adorned idols, and peaceful atmosphere."
    },
    {
      "title": "Saryu River Ghat",
      "description":
        "The Saryu River Ghats are sacred bathing and prayer spots where devotees perform rituals, aarti ceremonies, and experience spiritual peace along the riverbank."
    },
    {
      "title": "Nageshwarnath Temple",
      "description":
        "Nageshwarnath Temple is an ancient Shiva temple believed to be established by Kush, son of Lord Rama, and is an important religious site in Ayodhya."
    },
    {
      "title": "Treta Ke Thakur",
      "description":
        "Treta Ke Thakur is a historic temple believed to mark the place where Lord Rama performed Ashwamedha Yagna, showcasing ancient idols and religious heritage."
    },
    {
      "title": "Guptar Ghat",
      "description":
        "Guptar Ghat is a peaceful riverfront site along the Saryu River associated with the legend of Lord Rama’s departure from the earthly world."
    },
    {
      "title": "Ram Katha Park",
      "description":
        "Ram Katha Park is a cultural and religious venue where spiritual events, Ramayana discourses, and devotional programs are regularly organized."
    },
    {
      "title": "Tulsi Smarak Bhawan",
      "description":
        "Tulsi Smarak Bhawan is dedicated to Goswami Tulsidas, the composer of Ramcharitmanas, and includes a museum, library, and cultural center."
    },
    {
      "title": "Ayodhya Deepotsav Grounds",
      "description":
        "The Deepotsav celebration area in Ayodhya is famous for grand Diwali festivities where millions of diyas light up the city, creating a divine atmosphere."
    }
  ],



services: [
  {
    name: "Pune to Ayodhya Tour Package",
    description: "Pune to Ayodhya tour package provides comfortable and well-planned travel arrangements for devotees and tourists visiting the holy city of Ayodhya from Pune. Packages include comfortable vehicles, experienced drivers, and flexible travel schedules suitable for families, pilgrimage groups, and spiritual travelers. Pickup services are available from homes, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Tempo Travellers, and luxury travel options suitable for different group sizes. Flexible booking options allow convenient Pune to Ayodhya tour package reservations."
  },
  {
    name: "Pune to Ayodhya Package",
    description: "Pune to Ayodhya package service offers dependable travel solutions for passengers planning religious and sightseeing journeys from Pune to Ayodhya. Comfortable vehicles provide spacious seating and smooth highway travel suitable for family vacations, pilgrimage tours, and group travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient Ayodhya package reservations."
  },
  {
    name: "Ayodhya Tour from Pune",
    description: "Ayodhya tour from Pune service provides affordable and comfortable travel arrangements for passengers visiting Ram Mandir and nearby spiritual destinations in Ayodhya. Travelers can enjoy smooth interstate journeys with experienced drivers familiar with long-distance routes and pilgrimage travel. Vehicles ensure spacious seating and safe transportation suitable for religious tourism and family tours. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ayodhya tour reservations."
  },
  {
    name: "Pune to Ayodhya Trip Package",
    description: "Pune to Ayodhya trip package provides premium transportation and travel solutions for passengers seeking comfortable and spiritual journeys. Vehicles offer spacious seating, luggage capacity, and smooth ride quality suitable for tourism, temple visits, and religious travel. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya trip package reservations."
  },
  {
    name: "Pune to Ayodhya Travel Package",
    description: "Pune to Ayodhya travel package offers economical and comfortable pilgrimage transportation for families, groups, and tourists traveling from Pune to Ayodhya. Vehicles provide smooth highway travel suitable for one-way journeys, round trips, and extended spiritual tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya travel package reservations."
  },
  {
    name: "Pune to Ayodhya Holiday Package",
    description: "Pune to Ayodhya holiday package provides comfortable transportation for families and tourists planning sightseeing and spiritual holidays in Ayodhya. Vehicles ensure smooth interstate travel with spacious seating and luggage capacity suitable for tourism, religious visits, and long-distance journeys. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Ayodhya holiday package reservations."
  },
  {
    name: "Pune to Ayodhya Darshan Package",
    description: "Pune to Ayodhya darshan package offers spacious and economical transportation for devotees visiting Ram Mandir and other spiritual destinations in Ayodhya. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for pilgrimage tours and family darshan travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ayodhya darshan package reservations."
  },
  {
    name: "Pune to Ayodhya Ram Mandir Tour Package",
    description: "Pune to Ayodhya Ram Mandir tour package provides reliable transportation for pilgrims and tourists planning spiritual journeys to the Ram Mandir in Ayodhya. Vehicles ensure smooth city and interstate highway travel suitable for religious tourism, family tours, and pilgrimage trips. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ram Mandir tour package reservations."
  },
  {
    name: "Pune to Ayodhya Family Package",
    description: "Pune to Ayodhya family package offers comfortable transportation for family vacations and spiritual journeys from Pune to Ayodhya. Vehicles provide spacious seating and luggage space suitable for families, senior citizens, and group travelers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya family package reservations."
  },
  {
    name: "Cheap Pune to Ayodhya Package",
    description: "Cheap Pune to Ayodhya package provides affordable and comfortable transportation for passengers looking for budget-friendly pilgrimage travel options. Vehicles ensure smooth highway travel suitable for spiritual tours, tourism, and family travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost Ayodhya package reservations."
  },
  {
    name: "Best Pune to Ayodhya Tour",
    description: "Best Pune to Ayodhya tour service offers dependable transportation for passengers planning spiritual and sightseeing journeys to Ayodhya. Comfortable vehicles ensure smooth interstate travel suitable for temple visits, religious tourism, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya tour reservations."
  },
  {
    name: "Pune to Ayodhya Pilgrimage Tour",
    description: "Pune to Ayodhya pilgrimage tour provides reliable transportation for religious travelers visiting Ayodhya and nearby spiritual destinations. Vehicles ensure smooth highway travel suitable for temple visits, darshan tours, and pilgrimage journeys. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient pilgrimage tour reservations."
  },
  {
    name: "Pune to Ayodhya Package Booking",
    description: "Pune to Ayodhya package booking service provides premium transportation solutions for tourists and devotees seeking comfortable long-distance travel. Vehicles are suitable for pilgrimage tours, family travel, tourism, and sightseeing trips. Professional chauffeurs ensure safe driving and smooth travel experiences throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya package booking reservations."
  },
  {
    name: "Pune to Ayodhya Sightseeing Package",
    description: "Pune to Ayodhya sightseeing package offers comfortable transportation for travelers planning sightseeing tours around Ayodhya and nearby attractions. Vehicles provide spacious seating and smooth travel suitable for tourists, families, and pilgrimage groups. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya sightseeing package reservations."
  },
  {
    name: "Pune to Ayodhya Spiritual Tour",
    description: "Pune to Ayodhya spiritual tour service provides spacious and dependable transportation for spiritual journeys, temple visits, and pilgrimage tours from Pune to Ayodhya. Vehicles ensure comfortable seating, luggage space, and smooth highway travel suitable for long journeys and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ayodhya spiritual tour reservations."
  }
],

tableData: [
  ["Pune to Ayodhya Tour Package", "Pune to Ayodhya Package"],
  ["Ayodhya Tour from Pune", "Pune to Ayodhya Trip Package"],
  ["Pune to Ayodhya Travel Package", "Pune to Ayodhya Holiday Package"],
  ["Pune to Ayodhya Darshan Package", "Pune to Ayodhya Ram Mandir Tour Package"],
  ["Pune to Ayodhya Family Package", "Cheap Pune to Ayodhya Package"],
  ["Best Pune to Ayodhya Tour", "Pune to Ayodhya Pilgrimage Tour"],
  ["Pune to Ayodhya Package Booking", "Pune to Ayodhya Sightseeing Package"],
  ["Pune to Ayodhya Spiritual Tour", "Pune to Ayodhya Tour Package"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ayodhya Tour Package",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Ayodhya tour package service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe spiritual travel."
      },
      {
        WhyChooseheading: "Affordable Ayodhya Tour Package Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Ayodhya tour package pricing with transparent fare details and no hidden charges. Customers receive complete travel information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Ayodhya Tour Cab Availability",
        WhyChoosedescription: "Our Pune to Ayodhya tour package service operates 24 hours a day for Ram Mandir darshan, family pilgrimages, religious tours, group travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Vehicles",
        WhyChoosedescription: "All vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable long-distance pilgrimage travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Ayodhya Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Ayodhya taxi service, round-trip bookings, Ram Mandir darshan tours, and customized pilgrimage travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, Tempo Travellers, and Urbania suitable for pilgrims, families, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with long-distance interstate routes and ensure safe driving, smooth travel, and timely darshan for every spiritual journey to Ayodhya."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ayodhya tour package service?", answer: "Pune to Ayodhya tour package service provides comfortable transportation and pilgrimage travel arrangements between Pune and Ayodhya for Ram Mandir darshan and spiritual tours." },
    { question: "Is Pune to Ayodhya tour package available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Ayodhya tour package service." },
    { question: "Which vehicles are available for Pune to Ayodhya travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, Tempo Travellers, and Urbania vehicles." },
    { question: "Can I book a one-way cab from Pune to Ayodhya?", answer: "Yes, customers can book one-way as well as round-trip Pune to Ayodhya taxi and tour package services." },
    { question: "Do you provide Ram Mandir darshan travel packages?", answer: "Yes, Shivai Travels provides Ram Mandir darshan and customized Ayodhya pilgrimage travel packages." },
    { question: "Are all Pune to Ayodhya vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned and maintained for comfortable long-distance pilgrimage travel." },
    { question: "Can I book Pune to Ayodhya tour package online?", answer: "Yes, customers can easily book Pune to Ayodhya tour package service online or through phone booking." },
    { question: "Do you provide vehicles for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours, senior citizens, and group pilgrimage travel." },
    { question: "Are Pune to Ayodhya tour package fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Ayodhya tour package?", answer: "Yes, advance booking is available and recommended during weekends, holidays, festive seasons, and Ram Mandir pilgrimage periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Suresh Patil",
      feedback:
        "Booked Pune to Ayodhya tour package with Shivai Travels. Comfortable vehicle, smooth pilgrimage journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Vaishali Kulkarni",
      feedback:
        "Excellent Pune to Ayodhya taxi and tour package service. Affordable pricing, clean vehicle, and wonderful spiritual travel experience.",
      rating: 5
    }
  ];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ayodhya Tour Package",
  "image": "https://shivaitravels.com/assets/images/pune-to-ayodhya-tour-package.jpg",
  "description": "Book Pune to Ayodhya Tour Package with Shivai Travels for a comfortable and spiritual journey. Explore the holy city of Ayodhya with hassle-free travel, including Ram Mandir darshan, sightseeing, and family-friendly tour options with AC cab services.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Custom Package Price",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-ayodhya-tour-package"
  }
};


  return (
    <div>

<Helmet>
  <title>Pune to Ayodhya Tour Package | Ram Mandir Darshan Cab | Shivai Travels</title>

  <meta
    name="description"
    content="Book Pune to Ayodhya tour package with Shivai Travels for a spiritual and comfortable journey. Includes Ram Mandir darshan, sightseeing, and safe AC cab travel for families and pilgrims."
  />

  <meta
    name="keywords"
    content="pune to ayodhya tour package, pune to ayodhya package, ayodhya tour from pune, pune to ayodhya trip package, pune to ayodhya travel package, pune to ayodhya holiday package, pune to ayodhya darshan package, pune to ayodhya ram mandir tour package, pune to ayodhya family package, cheap pune to ayodhya package, best pune to ayodhya tour, pune to ayodhya pilgrimage tour, pune to ayodhya package booking, pune to ayodhya sightseeing package, pune to ayodhya spiritual tour"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoayodhyatour;